// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"fb421f06","220":"edca252f","339":"35a36d59","345":"98d8141b","701":"f8370fa2","906":"49e48bad"}[chunkId] + ".chunk.js";
};